var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnticorposOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.757,
    height: 22,
    viewBox: "0 0 27.757 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.757,
    height: 22,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.731,
    height: 2.155,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.485,
    height: 1.485,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.21,
    height: 1.485,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.308,
    height: 1.53,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.649,
    height: 0.709,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1272.181,161.277l-1.73,1.73-1.672-.617a1.02,1.02,0,0,0-1.39-1.39l-.617-1.672,1.729-1.73,1.672.617a1.02,1.02,0,0,0,1.39,1.39Z",
    transform: "translate(-1247.343 -155.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.287,161.277l1.73,1.73,1.672-.617a1.02,1.02,0,0,1,1.39-1.39l.617-1.672-1.73-1.73-1.672.617a1.02,1.02,0,0,1-1.39,1.39Z",
    transform: "translate(-187.368 -155.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.447,608.813v2.446l-1.618.746a1.02,1.02,0,0,0-1.965,0l-1.618-.746v-2.446l1.618-.746a1.02,1.02,0,0,0,1.965,0Z",
    transform: "translate(-723.968 -598.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.537,7.3v12.9a1.792,1.792,0,1,1-3.583.019V9.071a2.492,2.492,0,0,0-.73-1.762l-4.247-4.247A1.792,1.792,0,0,1,251.511.529l5.5,5.5a1.786,1.786,0,0,1,.525,1.267",
    transform: "translate(-244.641 -0.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.628 5.368)",
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M694.4,352.116a.23.23,0,0,1-.23-.23.79.79,0,0,0-.233-.562l-.971-.971a.23.23,0,0,1,.325-.325l.971.971a1.247,1.247,0,0,1,.368.887.23.23,0,0,1-.23.23",
    transform: "translate(-692.902 -349.961)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.348 0.537)",
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.683,36.49a.23.23,0,0,1-.23-.23,1.255,1.255,0,0,1,1.255-1.255.23.23,0,0,1,0,.46.795.795,0,0,0-.795.795.23.23,0,0,1-.23.23",
    transform: "translate(-283.453 -35.005)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M968.884,7.3v12.9a1.792,1.792,0,1,0,3.583.019V9.071a2.492,2.492,0,0,1,.73-1.762l4.247-4.247A1.792,1.792,0,0,0,974.91.529l-5.5,5.5a1.786,1.786,0,0,0-.525,1.267",
    transform: "translate(-954.023 -0.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.398 5.368)",
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1004.115,352.117a.23.23,0,0,1-.23-.23,1.247,1.247,0,0,1,.368-.887l.97-.971a.23.23,0,0,1,.325.325l-.971.971a.79.79,0,0,0-.233.562.23.23,0,0,1-.23.23",
    transform: "translate(-1003.885 -349.961)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.199 0.537)",
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1384.1,36.49a.23.23,0,0,1-.23-.23.795.795,0,0,0-1.357-.562.23.23,0,1,1-.325-.325,1.255,1.255,0,0,1,2.142.887.23.23,0,0,1-.23.23",
    transform: "translate(-1382.12 -35.005)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M5.391,169.682l-2.285,2.285L.473,169.333a1.615,1.615,0,0,1,0-2.285h0a1.616,1.616,0,0,1,2.285,0Z",
    transform: "translate(0 -164.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.537 3.092)",
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3,203.106a.23.23,0,0,1-.222-.171,1.083,1.083,0,0,1,.279-1.043l.014-.014a1.073,1.073,0,0,1,.748-.3.23.23,0,1,1,0,.46.615.615,0,0,0-.428.172l-.01.01a.621.621,0,0,0-.16.6.23.23,0,0,1-.222.29",
    transform: "translate(-35.041 -201.576)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M203.056,369.637a1.615,1.615,0,0,1-2.285,0l-2.327-2.327c-.213-.213.126-.9.757-1.528s1.308-.966,1.525-.76l2.33,2.33a1.615,1.615,0,0,1,0,2.285",
    transform: "translate(-195.338 -359.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.135,169.682l2.285,2.285,2.634-2.633a1.615,1.615,0,0,0,0-2.285h0a1.616,1.616,0,0,0-2.285,0Z",
    transform: "translate(-1435.77 -164.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.311 3.092)",
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1650.41,202.284a.23.23,0,0,1-.163-.393,1.079,1.079,0,0,1,1.511-.014.23.23,0,1,1-.32.331.618.618,0,0,0-.866.008.229.229,0,0,1-.163.067",
    transform: "translate(-1650.179 -201.575)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1276.066,369.637a1.616,1.616,0,0,0,2.285,0l2.327-2.327c.213-.213-.126-.9-.757-1.528s-1.308-.966-1.525-.76l-2.33,2.33a1.616,1.616,0,0,0,0,2.285",
    transform: "translate(-1256.027 -359.364)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnticorposOn);
export default __webpack_public_path__ + "static/media/Anticorpos-ON.d86916a9781d6a658633035759136a95.svg";
export { ForwardRef as ReactComponent };